import React from 'react'
import PropTypes from 'prop-types'

import {
  VARIANTS,
  PRIMARY_TYPE,
  SECONDARY_TYPE,
  TERTIARY_TYPE,
  BIG_SIZE,
  SIZES_VARIANTS,
} from './constants'
import Loader from 'src/comps/Atom/Loader'

import { colors } from 'client/styles'
import { ButtonText, ButtonSimpleBase, ButtonLoadingBase } from './styles'

const ButtonSimple = ({
  dataTestId,
  disabled = false,
  fullWidth = false,
  icon,
  isLoading = false,
  onClick,
  size = BIG_SIZE,
  text,
  variant,
}) => {
  const matchLoader = {
    [PRIMARY_TYPE]: colors.white,
    [SECONDARY_TYPE]: colors.magenta,
    [TERTIARY_TYPE]: colors.grey1,
  }

  return (
    <>
      <ButtonSimpleBase
        data-testid={dataTestId}
        disabled={disabled}
        fullWidth={fullWidth}
        isVisible={!isLoading}
        onClick={onClick}
        size={size}
        variant={variant}
      >
        {icon}
        <ButtonText>{text}</ButtonText>
      </ButtonSimpleBase>

      <ButtonLoadingBase
        data-testid={`${dataTestId}-loader`}
        fullWidth={fullWidth}
        isVisible={isLoading}
        onClick={e => e.preventDefault()}
        size={size}
        variant={variant}
      >
        <Loader isInline color={matchLoader[variant]} />
      </ButtonLoadingBase>
    </>
  )
}

ButtonSimple.propTypes = {
  dataTestId: PropTypes.string,
  disabled: PropTypes.bool,
  fullWidth: PropTypes.bool,
  icon: PropTypes.instanceOf(Object),
  isLoading: PropTypes.bool,
  onClick: PropTypes.func,
  size: PropTypes.oneOf(SIZES_VARIANTS),
  variant: PropTypes.oneOf(VARIANTS),
  text: PropTypes.oneOfType([
    PropTypes.shape({ id: PropTypes.string, defaultMessage: PropTypes.string }),
    PropTypes.string,
  ]),
}

export default ButtonSimple
